export const HEX_OVERLAY_SUPERCLUSTER_OPTIONS = Object.freeze({
  radius: 48,
  maxZoom: 24,
  minPoints: 2,
});

export const HEX_OVERLAY_CATEGORIES = Object.freeze({
  animals: Object.freeze({
    category: "animals",
    label: "Animal reports",
    sourceId: "hex-poc-animal-overlay",
    pointKind: "animal-report",
    clusterKind: "animal-cluster",
    pointLayerId: "hex-poc-animal-points",
    clusterLayerId: "hex-poc-animal-clusters",
    clusterCountLayerId: "hex-poc-animal-cluster-counts",
    color: "#7c3aed",
  }),
  environment: Object.freeze({
    category: "environment",
    label: "Environment reports",
    sourceId: "hex-poc-environment-overlay",
    pointKind: "environment-report",
    clusterKind: "environment-cluster",
    pointLayerId: "hex-poc-environment-points",
    clusterLayerId: "hex-poc-environment-clusters",
    clusterCountLayerId: "hex-poc-environment-cluster-counts",
    color: "#0891b2",
  }),
});

export const DEFAULT_HEX_OVERLAY_VISIBILITY = Object.freeze({
  animals: false,
  environment: false,
});

export const HEX_OVERLAY_STYLE = Object.freeze({
  pointRadius: 7,
  pointStrokeColor: "#ffffff",
  pointStrokeWidth: 1.5,
  clusterRadiusStops: Object.freeze([
    [2, 12],
    [10, 16],
    [50, 20],
    [180, 24],
  ]),
  clusterStrokeColor: "#ffffff",
  clusterStrokeWidth: 1.5,
  clusterOpacity: 0.94,
  clusterCountColor: "#ffffff",
  clusterCountSize: 12,
});

export function hexOverlayLayerIdsInOrder() {
  return Object.freeze(Object.values(HEX_OVERLAY_CATEGORIES).flatMap((config) => [
    config.pointLayerId,
    config.clusterLayerId,
    config.clusterCountLayerId,
  ]));
}

export function assertOverlayCategory(category) {
  if (!Object.hasOwn(HEX_OVERLAY_CATEGORIES, category)) {
    throw new TypeError(`Unknown hex overlay category: ${category}.`);
  }
  return category;
}

export function hexOverlayVisibility(options = DEFAULT_HEX_OVERLAY_VISIBILITY) {
  return Object.freeze(Object.fromEntries(
    Object.keys(HEX_OVERLAY_CATEGORIES).map((category) => [category, options?.[category] === true]),
  ));
}
